import { Observable } from 'rxjs';
import { combineEpics } from 'redux-observable';
import { uploadMediaAPI, deleteMediaAPI } from './api';
import { INIT, LOADING, SUCCESS, ERROR } from '../../utils/constants';


export const UPLOAD_MEDIA = 'advaice/media/UPLOAD_MEDIA';
export const UPLOAD_MEDIA_SUCCESS = 'advaice/media/UPLOAD_MEDIA_SUCCESS';
export const UPLOAD_MEDIA_ERROR = 'advaice/media/UPLOAD_MEDIA_ERROR';

export const DELETE_MEDIA = 'advaice/media/DELETE_MEDIA';
export const DELETE_MEDIA_SUCCESS = 'advaice/media/DELETE_MEDIA_SUCCESS';
export const DELETE_MEDIA_ERROR = 'advaice/media/DELETE_MEDIA_ERROR';

export const RESET_STORE = 'advaice/media/RESET_STORE';

const initialState = {
  uploadMediaStatus: INIT,
  uploadMediaError: INIT,
  deleteMediaStatus: INIT,
  deleteMediaError: '',
};

export const mediaStore = (state = initialState, action = {}) => {
  switch (action.type) {
    case UPLOAD_MEDIA: {
      return {
        ...state,
        uploadMediaStatus: LOADING,
      };
    }
    case UPLOAD_MEDIA_SUCCESS: {
      return {
        ...state,
        uploadMediaStatus: SUCCESS,
      };
    }
    case UPLOAD_MEDIA_ERROR: {
      return {
        ...state,
        uploadMediaStatus: ERROR,
        uploadMediaError: action.payload,

      };
    }
    case DELETE_MEDIA: {
      return {
        ...state,
      };
    }
    case RESET_STORE: {
      return {
        ...state,
        uploadMediaStatus: INIT,
        uploadMediaError: '',
      };
    }
    default: {
      return state;
    }
  }
};

export const uploadMedia = data => ({
  type: UPLOAD_MEDIA,
  payload: data,
});

export const resetStore = () => ({
  type: RESET_STORE,
});

export const deleteMedia = data => ({
  type: DELETE_MEDIA,
  payload: data,
});

export const uploadMediaObservable = (store, requestData) => Observable
  .fromPromise(uploadMediaAPI(requestData))
  .map(data => ({ type: UPLOAD_MEDIA_SUCCESS, payload: data }))
  .catch(err => Observable.of({ type: UPLOAD_MEDIA_ERROR, payload: err }));

export const deleteMediaObservable = (store, requestData) => Observable
  .fromPromise(deleteMediaAPI(requestData))
  .map(data => ({ type: DELETE_MEDIA_SUCCESS, payload: data }))
  .catch(err => Observable.of({ type: DELETE_MEDIA_ERROR, payload: err }));

export const uploadMediaEpic = (action$, store) => action$
  .ofType(UPLOAD_MEDIA)
  .flatMap(action => uploadMediaObservable(store, action.payload));

export const deleteMediaEpic = (action$, store) => action$
  .ofType(DELETE_MEDIA)
  .flatMap(action => deleteMediaObservable(store, action.payload));

export const mediaEpic = combineEpics(uploadMediaEpic, deleteMediaEpic);



// WEBPACK FOOTER //
// ./src/reducers/media/duck.js